import { Component, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ButtonStyle } from '@constants/button/1.0';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgFor, NgIf } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { ButtonComponent } from '../../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface CopyCatalogItemElement {
  id: string;
  name: string;
  checked: boolean;
  disabled?: boolean;
}

export interface CopyCatalogItemDialogData {
  title: string;
  elements: CopyCatalogItemElement[];
  confirmText: string;
  cancelText: string;
  showNameInput?: boolean;
  nameLabel?: string;
  initialName?: string;
}

@Component({
  selector: 'txp-copy-catalog-item-dialog',
  templateUrl: './copy-catalog-item-dialog.component.html',
  styleUrls: ['./copy-catalog-item-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    NgFor,
    NgIf,
    MatCheckbox,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
  ],
})
export class CopyCatalogItemDialogComponent {
  buttonStyle = ButtonStyle;
  selectedElements: CopyCatalogItemElement[];
  newItemName = '';

  constructor(
    private dialogRef: MatDialogRef<CopyCatalogItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CopyCatalogItemDialogData,
  ) {
    // Initialize with default selections
    this.selectedElements = this.data.elements.map((element) => ({ ...element }));
    this.newItemName = this.data.initialName || '';
  }

  onElementChange(elementId: string, checked: boolean) {
    const element = this.selectedElements.find((el) => el.id === elementId);
    if (element && !element.disabled) {
      element.checked = checked;
    }
  }

  handleCopy() {
    const selectedElements = this.selectedElements.filter((el) => el.checked);
    if (this.data.showNameInput) {
      const name = (this.newItemName || '').trim();
      if (!name) return;
      return this.dialogRef.close({
        elements: selectedElements,
        name,
      });
    }
    return this.dialogRef.close(selectedElements);
  }

  handleCancel() {
    this.dialogRef.close();
  }
}
